module.exports = __webpack_public_path__ + "assets/img/66ba9184ee5ee38e05fe6373d30994d8.svg";